import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyC3INPHjDco3jV0dvWgpLI6Y48hY-P6TaM",
  authDomain: "potluck-9983d.firebaseapp.com",
  databaseURL: "https://potluck-9983d.firebaseio.com",
  projectId: "potluck-9983d",
  storageBucket: "potluck-9983d.appspot.com",
  messagingSenderId: "587687750115",
  appId: "1:587687750115:web:42593214c36bc9cd"
};

firebase.initializeApp(config);
export const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();

export default firebase;